import React from 'react'

function DisabledSVG(){

  return (
    <svg>
      <line x1="0" y1="100%" x2="100%" y2="0" stroke="#E8E8E8"></line>
      <line x1="0" y1="0" x2="100%" y2="100%" stroke="#E8E8E8"></line>
    </svg>
  )
}

export default DisabledSVG